import { useState, useEffect } from 'react';
import { propertyTypeService } from '@/services/propertyType.service';

export function usePropertyTypeOptions() {
  const [options, setOptions] = useState<{ label: string; value: string; disabled: boolean }[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    propertyTypeService.getAllPropertyTypes()
      .then(types => {
        setOptions(
          types
            .filter(t => t.isActive)
            .map(t => ({ label: t.name, value: t.name, disabled: false }))
        );
      })
      .catch(() => setOptions([]))
      .finally(() => setLoading(false));
  }, []);

  return { options, loading };
}
